<template>
    <div>
        <div v-show="!isEditing">
            <div>
                <div class="card-header">
                    <p class="card-header-title">{{ data.name }}</p>
                </div>
                <div class="card-content">
                    <b-taglist>
                        <b-tag type="is-link" v-for="category in data.categories" v-bind:key="category._id">{{ category.name }}</b-tag>
                    </b-taglist>
                </div>
                <footer class="card-footer">
                    <a href="#" class="card-footer-item" v-on:click="editData()">Edit</a>
                    <a href="#" class="card-footer-item" v-on:click="deleteData(data)">Delete</a>
                </footer>
            </div>
        </div>
        <div v-show="isEditing">        
            <div class="card-header">
                <p class="card-header-title">Edit School Type</p>
            </div>
            <div class="card-content">
                <div class="content">
                    <div class="field">
                        <input class="input is-success" type="text" placeholder="Class/Department Name" v-model="data.name">
                    </div>
                    <div class="field">
                        <multiselect v-model="data.categories" :options="listCategory" :close-on-select="false" :multiple="true" :hide-selected="true" label="name" track-by="name" placeholder="Select the categories for this school type"></multiselect>
                    </div>
                    <div class="field">
                        <button class='button is-primary' v-on:click="updateData(data)">Update</button>
                        <button class='button is-secondary' v-on:click="cancelEdit()">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Multiselect from 'vue-multiselect'
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    name: "SuperSchoolTypeView",
    components: {
        Loading,
        Multiselect
    },
    data() {
        return {
            superId: "",
            superEmail: "",
            _id: "",            
            isEditing: false,
            schoolTypeData: [],
            isLoading: false
        };
    },
    props: ['data','listCategory'],
    created() {
        // this.getItems()
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    mounted() {},
    methods: {
        deleteData(data) {
            this.$emit('delete-data', data);
        },
        editData() {
            this.isEditing = true;
        },
        cancelEdit(){
            this.isEditing = false;
        },
        updateData(data) {
            this.$emit('update-data', data);
            this.isEditing = false;
        },
        goHome() {
            this.$router.push({
                name: "SuperHome"
            });
        },
        goSuperItems() {
            this.$router.push({
                name: "SuperItems"
            });
        },
    }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
html,
body {
    font-size: 16px;
    line-height: 1.5;
    height: 100%;
    background: #ecf0f3;
}
nav.navbar {
    border-top: 4px solid #276cda;
    margin-bottom: 1rem;
}
.navbar-item.brand-text {
    font-weight: 300;
}
.navbar-item,
.navbar-link {
    font-size: 14px;
    font-weight: 700;
}
.columns {
    width: 100%;
    height: 100%;
    margin-left: 0;
}
.menu-label {
    color: #8f99a3;
    letter-spacing: 1.3;
    font-weight: 700;
}
.menu-list a {
    color: #0f1d38;
    font-size: 14px;
    font-weight: 700;
}
.menu-list a:hover {
    background-color: transparent;
    color: #276cda;
}
.menu-list a.is-active {
    background-color: transparent;
    color: #276cda;
    font-weight: 700;
}
.card {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
    margin-bottom: 2rem;
}
.card-header-title {
    color: #8f99a3;
    font-weight: 400;
}
.info-tiles {
    margin: 1rem 0;
}
.info-tiles .subtitle {
    font-weight: 300;
    color: #8f99a3;
}
.hero.welcome.is-info {
    background: #36d1dc;
    background: -webkit-linear-gradient(to right, #5b86e5, #36d1dc);
    background: linear-gradient(to right, #5b86e5, #36d1dc);
}
.hero.welcome .title,
.hero.welcome .subtitle {
    color: hsl(192, 17%, 99%);
}
.card .content {
    font-size: 14px;
}
.card-footer-item {
    font-size: 14px;
    font-weight: 700;
    color: #8f99a3;
}
.card-table .table {
    margin-bottom: 0;
}
.events-card .card-table {
    max-height: 250px;
    overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Super/SchoolTypeView.vue